import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { Environment, useGLTF } from '@react-three/drei';


const Model = () => {
  const gltf = useGLTF('/models/face21.glb'); 
  return <primitive object={gltf.scene} scale={1} position={[0,-2,0]}/>;
};

const FaceModel = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '700px',
        height: '700px',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1, 
      }}
    >
      <Canvas camera={{ position: [30, 6, -1], fov: 10 }} shadows={true}>
        <ambientLight intensity={1}/>
        <directionalLight position={[12, 10, 5]} intensity={1} />
        <Suspense fallback={null}>
          <Model />
          
        </Suspense>
      </Canvas>
    </div>
  );
};

useGLTF.preload('/models/face21.glb');

export default FaceModel;
